module.exports = __webpack_public_path__ + "static/media/Typologie_objektu.1045588a.md";